import { Spinner } from "@/external/ensolvers-core-frontend-mui-v5/components/Common/Spinner";
import { SxProps } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Dispatch, SetStateAction } from "react";
import CommonButton, { CommonButtonSecondarySx } from "../utils/CommonButton";
import LazoModal from "../utils/LazoModal";

type Props = {
  anchor: HTMLElement;
  setAnchorElement: Dispatch<SetStateAction<HTMLElement>>;
  onConfirm: (ev?: React.MouseEvent) => void;
  onClose?: () => void;
  loading?: boolean;
  text?: string;
  buttonSx?: SxProps;
};

export function GenericConfirmModal(props: Props) {
  function onClose() {
    props.onClose?.();
    props.setAnchorElement(null);
  }

  return (
    <>
      <LazoModal
        title={<Typography fontWeight="600">Confirm</Typography>}
        open={Boolean(props.anchor)}
        handleClose={onClose}
        buttons={[
          <CommonButton onClick={onClose} sx={{ ...CommonButtonSecondarySx, borderRadius: "0.5rem" }}>
            <Typography>Close</Typography>
          </CommonButton>,
          <CommonButton disabled={props.loading} onClick={(ev) => props.onConfirm(ev)} sx={{ borderRadius: "0.5rem", ...props.buttonSx }}>
            {props.loading ? <Spinner size={"1rem"} /> : <Typography>Confirm</Typography>}
          </CommonButton>,
        ]}
      >
        <Typography>{props.text ? props.text : "Are you sure you want to do this?"}</Typography>
      </LazoModal>
    </>
  );
}
